module.exports = __webpack_public_path__ + "static/media/PR.ada6a0eb.jpg";